import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id A4F7E2E4-704C-4A71-99D5-4BD19AD8E755
 * name fullscreen
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/fullscreen.svg
 * tags
 */
export const FullscreenIcon = createSvgIcon(<><path d="M5,5H10V7H7V10H5V5M14,5H19V10H17V7H14V5M17,14H19V19H14V17H17V14M10,17V19H5V14H7V17H10Z" /></>, 'FullscreenIcon');
export default FullscreenIcon